import React, { useContext, useEffect, useState } from 'react'
import * as Accordion from "@radix-ui/react-accordion";
import { FaPlus } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { ExamcompassClient } from '../Api/api';
import { ExamCompassContext } from '../Context/context'


// svg
import chat from '../Assets/quote.svg'
import bolt from '../Assets/bolt.svg'

interface FaqType {
  id: number;
  question: string;
  answer: string;
}

const Faq:React.FC = () => {
  const { about } = useContext(ExamCompassContext)

  const [faq, setFaq] = useState<FaqType[] | null>(null)
  const [showAnswer, setShowAnswer] = useState<number | null>(null);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const response = await ExamcompassClient.get('/info/faq_list')
        setFaq(response.data)
      } catch (err) {
        console.log('Something went wrong')
      }
    }

    fetchFaq()
  }, [])

  faq?.sort((a, b) => a.id - b.id);

  const handleFaq = (id: number) => {
    setShowAnswer(prev => prev === id ? null  : id)
  }

  return (
    <section className='py-12 relative'>
      <img src={bolt} alt='bolt' className='absolute right-5 top-28 md:top-20' />
      <div className='container'>
        <h2 className='text-[36px] text-center font-bold mb-12'>Frequently Asked Questions</h2>
        <div className=' lg:flex justify-between flex-wrap'>
          <div className='w-[340px] md:w-[590px] lg:w-[751px] mx-auto mb-20'>
            <Accordion.Root
              className="w-full"
              type="single"
              collapsible
            >
              {faq?.map(faq => (
                <Accordion.Item key={faq.id} className="mb-9 shadow-customShadow w-full" value={`item-${faq.id}`}>
                  <Accordion.Trigger onClick={() => handleFaq(faq.id)} className='w-full p-3 flex items-center justify-between'>
                    <p className='text-darkText text-left font-semibold w-[87%]' dangerouslySetInnerHTML={{ __html: faq.question }}></p>
                    {showAnswer === faq.id ? <FaTimes /> : <FaPlus />}
                  </Accordion.Trigger>
                  <Accordion.Content className='w-full p-3'>
                    <p className='w-[90%] text-textColor' dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                  </Accordion.Content>
                </Accordion.Item>
              ))}
            </Accordion.Root>
          </div>

          <div className='w-[340px] md:w-[401px] lg:h-[512px] mx-auto pt-11 pb-5 md:pb-7 md:pt-16 lg:pb-4 px-4 flex flex-col items-center shadow-customShadow'>
            <img src={chat} alt='Chat icon' className='mx-auto mb-7' />
            <p className='text-[22px] text-darkText text-center font-bold mb-6'>Do you have more questions?</p>
            <p className='text-darkText text-center mb-16 lg:px-7 leading-[26px] md:leading-[31px]'>Have something on your mind? We're here to help! If you have any questions about ExamCompass, our features, or plans, don’t hesitate to reach out.</p>
            <a href={`mailto:${about ? about.email : 'support@examcompassng.com'}`} className='w-[300px] md:w-[337px] h-[76px] bg-darkGreen text-lemonGreen mb-0 flex items-center justify-center cursor-pointer'>Shoot a Direct Mail</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Faq